export const DIRECTORY_KEY = 'directory-v6';

// Clean up previous versions
for (let i = 0; i < localStorage.length; i++) {
  const key = localStorage.key(i);
  if (key && key.startsWith('directory-v') && key !== DIRECTORY_KEY) {
    localStorage.removeItem(key);
  }
}
